export const FLOATING_ROOT_ID = 'pds-floating-root';

export const FLOATING_ORDER: Array<'reference' | 'floating' | 'content'> = ['floating', 'content'];
